module.exports = __webpack_public_path__ + "img/pt-14.e1701531.jpg";